import * as React from 'react'
import { TableCell } from '../atoms/table'
import type { OrderDetails } from '@/types'
import { TableBody } from '../atoms/table'
import { Table, TableHead, TableHeader, TableRow } from '../atoms/table'
import { ShowAsDollars } from '../atoms/ShowNumberAsDollars'

export type ShowOrderDetailsProps = {
  order: OrderDetails | null
  isLoading: boolean
}

export function ShowOrderDetails(props: ShowOrderDetailsProps) {
  if(props.isLoading) {
    return(<div>
      <h1>Loading...</h1>
    </div>)
  }
  if(props.order) {
    return(
      <div className='grid gap-4 py-4'>
        <h3 className='section-title'>{props.order.invoice.invoiceNo}</h3>
        <Table>
          <TableHeader>
            <TableRow>
              <TableHead>SKU</TableHead>
              <TableHead>MPN</TableHead>
              <TableHead>DESCRIPTION</TableHead>
              <TableHead>PRICE</TableHead>
              <TableHead>QTY</TableHead>
              <TableHead>SUBTOTAL</TableHead>
            </TableRow>
          </TableHeader>
          <TableBody>
            {
              props.order.orderItems.map(item => (
                <TableRow key={item._id}>
                  <TableCell>
                    { item.product.sku }
                  </TableCell>
                  <TableCell>
                    { item.product.mpn}
                  </TableCell>
                  <TableCell>{item.product.description}</TableCell>
                  <TableCell><ShowAsDollars number={item.spAsCents} /></TableCell>
                  <TableCell>{item.qty}</TableCell>
                  <TableCell><ShowAsDollars number={item.subtotalAsCents} /></TableCell>
                </TableRow>
              ))
            }
          </TableBody>
        </Table>
        <div className='flex flex-row justify-between'>
          <div className='basis-1/2 text-lg font-bold'>
            TOTAL
          </div>
          <div className='basis-1/2 text-lg font-bold text-right'>
            <ShowAsDollars number={props.order.totalAsCents} />
          </div>
        </div>
      </div>

    )
  }
}